"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupPuppeteerTimeout = exports.PUPPETEER_TIMEOUT_KEY = exports.DEFAULT_PUPPETEER_TIMEOUT = void 0;
exports.DEFAULT_PUPPETEER_TIMEOUT = 30000;
exports.PUPPETEER_TIMEOUT_KEY = 'remotion.puppeteerTimeout';
const getPuppeteerTimeout = () => {
    const param = localStorage.getItem(exports.PUPPETEER_TIMEOUT_KEY);
    return param ? Number(param) : exports.DEFAULT_PUPPETEER_TIMEOUT;
};
const setupPuppeteerTimeout = () => {
    window.remotion_puppeteerTimeout = getPuppeteerTimeout();
};
exports.setupPuppeteerTimeout = setupPuppeteerTimeout;
